<template>
	<section class='section-logos'>
		<h2
			class="center"
			v-html="`Hanno parlato di noi`"
		/>
		<div class="row pt-5 mx-10" v-if="!$mq.isDesktop()">
			<SliderQ
				:minSizeOfSlide="200"
				:maxNumSlides='brands.length' 
				:arrows="!$mq.isDesktop()"
				class="center"
			>
				<slide
					v-for="(brand, index) in brands"
					:key="index"
				>
					<img :src="brand.img" :alt="brand.name" loading="lazy">
				</slide>
			</SliderQ>
		</div>
		<div v-else class='container-logos'>
			<div v-for="(item, index) in brands" :key="index">
				<img :src="item.img" :alt='item.name' loading="lazy">
			</div>
		</div>
	</section>
</template>

<script>

export default {

	data () {
		return {
			brands: [
				{ name: 'Vanity Fair', img: require('../../assets/img/brands/Vanity.png') },
				{ name: 'Wired', img: require('../../assets/img/brands/Wired.png') },
				{ name: 'Gambero Rosso', img: require('../../assets/img/brands/Gambero.png') },
				{ name: 'Cosmopolitan', img: require('../../assets/img/brands/Cosmopolitan.png') },
				{ name: 'La Repubblica', img: require('../../assets/img/brands/Repubblica.png') },
				{ name: 'Il Sole 24', img: require('../../assets/img/brands/Il_Sole_24.png') },
				{ name: 'Corriere della Sera', img: require('../../assets/img/brands/Corriere_della_Sera.png') }
			]
		}
	}
}
</script>

<style scoped>
.section-logos {
	padding: 30px 0;
}
.container-logos{
    display:flex;
    align-items: center;
    justify-content:space-around;
    flex-wrap:wrap;
}
.container-logos img{
    max-width:130px;
    margin:20px 20px;
    opacity: 0.7;
}
</style>
